import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export function YearsInput({
  id,
  value,
  missing,
  autoFocus,
  onChange
}: {
  id: string
  value: number
  missing: boolean
  autoFocus?: boolean
  onChange: (n: number) => void
}) {
  return (
    <div className='flex items-center gap-2'>
      <Label
        htmlFor={id}
        className='shrink-0 text-[11px] font-medium text-ink-muted'
      >
        Years of Experience
        {missing && <span className='ml-0.5 text-red-500'>*</span>}
      </Label>
      <Input
        id={id}
        type='text'
        inputMode='numeric'
        pattern='[0-9]*'
        maxLength={3}
        placeholder='0'
        aria-required
        aria-invalid={missing || undefined}
        autoFocus={autoFocus}
        value={value === 0 ? '' : value.toString()}
        onChange={e => {
          const digits = e.target.value.replace(/\D/g, '')
          const n = digits === '' ? 0 : Math.min(200, Number(digits))
          onChange(n)
        }}
        className={`h-11 w-16 text-center sm:h-7 sm:w-12 ${missing ? 'border-amber-400 dark:border-amber-600' : ''}`}
      />
    </div>
  )
}
